import { render } from "./Pay.vue?vue&type=template&id=34975c4e&ts=true"
import script from "./Pay.vue?vue&type=script&lang=ts"
export * from "./Pay.vue?vue&type=script&lang=ts"

import "./Pay.vue?vue&type=style&index=0&id=34975c4e&lang=scss"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__